import React from 'react';
import { LoadIndicator } from 'devextreme-react/load-indicator';

interface ReferralTableLoadIndicatorProps {
    message?: string;
    height?: number;
    width?: number;
}

export const ReferralTableLoadIndicator: React.FC<ReferralTableLoadIndicatorProps> = ({
    message = 'Loading your Referrals',
    height = 24,
    width = 24,
}) => {
    return (
        <div className='brokerReferralTableLoadingIndicator'>
            <LoadIndicator
                height={height}
                width={width}
            />
            <span className='brokerReferralTableLoadingIndicator-message'>{message}</span>
        </div>
    );
};
